import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Role } from 'app/interfaces/role';
import { Usuario } from 'app/interfaces/usuario';
import { UsuarioHttpService } from '../../usuario-http.service';

@Component({
  selector: 'app-usuario-details-permissoes',
  templateUrl: './usuario-details-permissoes.component.html',
  styleUrls: ['./usuario-details-permissoes.component.scss']
})
export class UsuarioDetailsPermissoesComponent implements OnInit {

  @Input() usuario: Usuario;
  form: FormGroup;
  roles: Role[];
  openedRecursos = new Set<number>();
  openedRoles = new Set<number>();
  filterText = '';

  constructor(
    private _activeModal: NgbActiveModal,
    private _usuarioHttpService: UsuarioHttpService,
    private _fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initForm();

      this._usuarioHttpService.getRolesRecursosPermissoesByUsuario(this.usuario.usuId).subscribe({
        next: (roles) => {
          this.roles = roles;
          this.populateForm(this.roles);
          },
      });

  }

  /**
   * Método para inicializar o formulário;
   */
  initForm() {
    this.form = this._fb.group({
      rolId: [null, [Validators.required]],
      nome: [null, [Validators.required]],
      recursos: this._fb.array([])
    });
  }

  
populateForm(roles: Role[]) {
  this.form.patchValue({
    rolId: roles.length ? roles[0].rolId : null,
    nome: roles.length ? roles[0].nome : null
  });

  const recursosArray = this.form.get('recursos') as FormArray;
  recursosArray.clear();

  roles.forEach(role => {
    role.recursos.forEach(rec => {
      const recursoGroup = this._fb.group({
        roleRecursoId: [rec.roleRecursoId, [Validators.required]],
        recurso: this._fb.group({
          recursoId: [rec.recurso?.recId || null, [Validators.required]],
          nome: [rec.recurso?.nome || null, [Validators.required]]
        }),
        permissoes: this._fb.array([])
      });

      const permissoesArray = recursoGroup.get('permissoes') as FormArray;
      rec.permissoes.forEach(per => {
        permissoesArray.push(this._fb.group({
          perId: [per.perId, [Validators.required]],
          codigo: [per.codigo, [Validators.required]],
          nome: [per.nome, [Validators.required]],
          dataCriacao: [per.dataCriacao, [Validators.required]],
          descricao: [per.descricao]
        }));
      });

      recursosArray.push(recursoGroup);
    });
  });
}


toggleRole(roleId: number) {
  if (this.openedRoles.has(roleId)) {
    this.openedRoles.delete(roleId);
  } else {
    this.openedRoles.add(roleId);
  }
}

togglePermissoes(roleRecursoId: number) {
  if (this.openedRecursos.has(roleRecursoId)) {
    this.openedRecursos.delete(roleRecursoId);
  } else {
    this.openedRecursos.add(roleRecursoId);
  }
}

// Abre todos os roles e seus recursos
expandAll() {
  this.openedRoles.clear();
  this.openedRecursos.clear();

  this.roles.forEach(role => {
    this.openedRoles.add(role.rolId);
    role.recursos.forEach(rec => {
      this.openedRecursos.add(rec.roleRecursoId);
    });
  });
}

// Fecha todos os roles e recursos
collapseAll() {
  this.openedRoles.clear();
  this.openedRecursos.clear();
}

  /**
   * Método para fechar o modal sem processar nada;
   */
  close() {
    this._activeModal.dismiss();
  }


  get f() {
    return this.form.controls;
  }

get filteredRoles(): Role[] {
  if (!this.filterText) return this.roles;

  const filtro = this.filterText.toLowerCase();

  return this.roles
    .map(role => {
      const recursosFiltrados = role.recursos.filter(rec =>
        rec.recurso.nome.toLowerCase().includes(filtro)
      );

      if (role.nome.toLowerCase().includes(filtro) || recursosFiltrados.length > 0) {
        return { ...role, recursos: recursosFiltrados };
      }

      return null;
    })
    .filter(role => role !== null);
}

onFilterChange(value: string) {
  this.filterText = value.trim();

  if (!this.filterText) {
    this.openedRoles.clear();
    this.openedRecursos.clear();
  } else {
    this.openedRoles.clear();
    this.openedRecursos.clear();

    this.filteredRoles.forEach(role => {
      this.openedRoles.add(role.rolId);
      role.recursos.forEach(rec => {
        this.openedRecursos.add(rec.roleRecursoId);
      });
    });
  }
}

}
